/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { SalespersonTotalDto } from '../dto';

export const SalespersonTotalMapper = entity<SalespersonTotalDto>({});
